export default {"src":"/_next/static/media/being-active.mono.7f13a7e9.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};